import Vue from 'vue'
import moment from 'moment-timezone';
export function hasBtn(btnName)
{
    return true
    // let btn = sessionStorage.getItem('btnList') ||[];
    // if (btn.length==0){
    //     return null
    // }else {
    //     return btn.indexOf(btnName) > -1;
    // }
}
export function getBtnStatus(path) {
    this.$post('admin_base_api/login',{path:path}).then((res)=>{
        if (res.status == 200){
            sessionStorage.setItem('btnList',res.data);
        }else {
            this.$message.error(res.message)
        }
        
    })
}
// 根据下标删除数组数据
export function removeByIndex(arr,index) {
    for(var i=0; i<arr.length; i++) {
        if(i == index) {
            arr.splice(i, 1);
            break;
        }
    }
}
// 时间格式
export function getTime(/** timestamp=0 **/) {  
    var ts = arguments[0] || 0;  
    var t,y,m,d,h,i,s;  
    t = ts ? new Date(ts*1000) : new Date();
    y = t.getFullYear();    //年
    m = t.getMonth()+1;    // 月
    d = t.getDate();    //日
    h = t.getHours();    //时
    i = t.getMinutes();    //分
    s = t.getSeconds();   //秒
    // 可根据需要在这里定义时间格式  
    if (arguments[1]=='y') {
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='m'){
        return (m<10?'0'+m:m)+'/'+(d<10?'0'+d:d);
    }else if(arguments[1]=='d'){
        return (d<10?'0'+d:d); 
    }else if(arguments[1]=='h'){
        return (h<10?'0'+h:h)+':'+(i<10?'0'+i:i);
    }else if(arguments[1]=='mm'){
        return (m<10?'0'+m:m)
    }else{
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)+' '+(h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);  
    }
}
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}
// 美国时间格式
export function getTime_us(/** timestamp=0 **/) {
    if (arguments[0]) {
        var ts = arguments[0] || 0;  
        var t,y,m,d,h,i,s;  
        t = ts ? new Date(ts*1000) : new Date();
        y = t.getFullYear();    //年
        m = t.getMonth()+1;    // 月
        d = t.getDate();    //日
        h = t.getHours();    //时
        i = t.getMinutes();    //分
        s = t.getSeconds();   //秒
        // 可根据需要在这里定义时间格式 
        if (arguments[1]=='yyyy') {
            return y 
        }else if (arguments[1]=='mmddyyyy'){
            return (m<10?'0'+m:m)+'/'+(d<10?'0'+d:d)+'/'+y
        }else if (arguments[1]=='mmddyy'){
            return m+'/'+(d<10?'0'+d:d)+'/'+y
        }else if(arguments[1]=='mmdd'){
            return (m<10?'0'+m:m)+'/'+(d<10?'0'+d:d)
        }else if(arguments[1]=='ampm'){
            var ampm=((h >12) ? h -12 :h) + ':' + (i<10?'0'+i:i);
            ampm+= (h >= 12) ? "pm" : "am";
            return ampm;
        }else if(arguments[1]=='mmddyyyyampm'){
            var ampm=((h >12) ? h -12 : h) + ':' + (i<10?'0'+i:i);
            ampm+= (h >= 12) ? "pm" : "am";
            return (m<10?'0'+m:m)+'/'+(d<10?'0'+d:d)+'/'+y+ '  ' +ampm;
        }else{
            var ampm=((h >12) ? h -12 :h) + ':' + (i<10?'0'+i:i);
            ampm+= (h >= 12) ? "pm" : "am";
            return (m<10?'0'+m:m)+'/'+(d<10?'0'+d:d)+'/'+y+' '+ampm; 
        }
    }
    return '';
}
export function getTime_us_f(data) {
    if (data) {
        // 2024/12/09改成第一节课时间
        var data_date = data.split(',')[0];
        var date = new Date(Number(data_date));
        var year = date.getFullYear();
        return year;
        // var data_array=data?data.split(','):[];
        // var arr=[];
        // data_array.forEach(function(e,i) {
        //     if (e.length>10) {
        //         var date = new Date(Number(e));
        //     }else{
        //         var date = new Date(Number(e)*1000);
        //     }
        //     arr[i]=date.getFullYear();
        // });
        // let lastArr = []
        // let sort_list = []
        // let newArr = [...new Set(arr)];
        // newArr.forEach(item=>{
        //     let num = 0
        //     arr.forEach(i=>{
        //         if(item==i){
        //             num++
        //         }
        //     })
        //     lastArr.push({
        //         name:item,
        //         num
        //     });
        //     sort_list.push(num);
        // })
        // var num=sort_list.sort((a, b) => { return b-a })[0];
        // var session=lastArr.filter(item => {return item.num==num})
        // return session&&session[0].name;
    }else{
        return '';
    }
}
// 根据上课时间日期获取上课星期并去重
export function getTime_week(data){
    if (data) {
        var this_=this;
        var data_array=data?data.split(','):[];
        let dateObj =[];
        let show_day = new Array('Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday');
        let show_day_z = new Array('星期日','星期一','星期二','星期三','星期四','星期五','星期六');
        var day_array=[];
        data_array.forEach(function(e,i) {
            if (e.length>10) {
                var date = new Date(Number(e));
            }else{
                var date = new Date(Number(e)*1000);
            }
            let day = date.getDay();
            day_array.push(day);
        });
        var new_day_array=this_.unique1(day_array).sort();
        var hash=[];
        for (var i = 0; i < new_day_array.length; i++) {
            var show=(this_.lang=='cn'?show_day_z[new_day_array[i]]:show_day[new_day_array[i]]);
            hash[i]=show;
        }
        return hash.length>0?hash.join(','):'';
    }else{
        return '';
    }
}
// 根据上课时间日期获取上课星期并去重
export function getTime_week_(data){
    var this_=this;
    let show_day = new Array('Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday');
    let show_day_z = new Array('星期日','星期一','星期二','星期三','星期四','星期五','星期六');
    if (data.length>10) {
        var date = new Date(Number(data));
    }else{
        var date = new Date(Number(data)*1000);
    }
    let day = date.getDay();
    var show=(this_.lang=='cn'?show_day_z[day]:show_day[day]);
    return show;
}
// 夏令营第几周回显
export function week_f(v){
    var cn_array=['','第一周','第二周','第三周','第四周','第五周','第六周','第七周','第八周','第九周','第十周'];
    var en_array=['','week 1','week 2','week 3','week 4','Week 5','Week 6','Week 7','Week 8','Week 9','Week 10'];
    var fanhuizhi=en_array[v];
    if (this.lang=='cn') {
        fanhuizhi=cn_array[v];
    }
    return fanhuizhi;
}
// 显示用户所在时区缩写
export function getTime_zone() {
    var zone = moment.tz.guess();
    var abbr = moment().tz(zone).format("z");
    return abbr
}
// 是否是手机
export function isMobile() {
    var userAgentInfo = navigator.userAgent;
    var mobileAgents = [ "Android", "iPhone", "SymbianOS", "Windows Phone", "iPad","iPod"];
    var mobile_flag = false;
    //根据userAgent判断是否是手机
    for (var v = 0; v < mobileAgents.length; v++) {
      if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true;
          break;
      }
    }
    var screen_width = window.screen.width;
    var screen_height = window.screen.height;   
    //根据屏幕分辨率判断是否是手机
    if(screen_width < 500 && screen_height < 800){
       mobile_flag = true;
    }
    return mobile_flag;
}
// 数组去重
export function unique1(arr){
    var hash=[];
    for (var i = 0; i < arr.length; i++) {
        if(hash.indexOf(arr[i])==-1){
            hash.push(arr[i]);
        }
    }
    return hash;
}

export function price_discount(data){
    if (data.early_price!=data.price) {
        return false;
    }
    // var date=Math.round(new Date().getTime()/1000);
    // var early_start_time=data.early_start_time;
    // var early_end_time=data.early_end_time;
    // if (early_start_time&&early_start_time) {
    //     if (early_start_time<date&&date<early_end_time) {
    //         return false;
    //     }
    // }
    return true;
}

export function detectZoom() {
    let ratio = 0;
    var u = navigator.userAgent.match(/(Mac)/i);
    const screen = window.screen
    const ua = navigator.userAgent.toLowerCase();
    if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
    } else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
            ratio = screen.deviceXDPI / screen.logicalXDPI
        }
    } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth
    }
    if (u==null) {
        document.body.style.zoom = 1 / ratio;
    }else{
        let windowWidth = document.documentElement.offsetWidth || document.body.offsetWidth;
        document.body.style.zoom = windowWidth / 1720
    }
}



//////////////////
// WEBPACK FOOTER
// ./store/store.js
// module id = null
// module chunks = 